import { currentSelectedRequest } from '@Features/store/selectors/manageRequestSelector';
import { useAppSelector } from '@Hooks/index';
import { PageTypes } from '@Enum/PageTypes.enum';

import { usePageType } from './usePageType';

export const prepareHeaderCaption = (
  pageType: string | undefined,
  selectedRequest: string,
  isMobile = false
): string | null => {
  switch (pageType) {
    case PageTypes.EDIT_MY_REQUEST:
      return isMobile ? `Edit ${selectedRequest}` : 'Back to my requests';
    case PageTypes.CREATE_MY_REQUEST:
      return isMobile ? `Add New ${selectedRequest}` : 'Back to my requests';
    case PageTypes.CREATE_PROCUREMENT:
      return isMobile ? `Create Tender` : 'Back to procurement';
    case PageTypes.RESPOND_TASK:
      return 'Back to my approvals';
    default:
      return null;
  }
};

export const useHeaderCaption = (isMobile: boolean): string | null => {
  const pageType = usePageType();
  const selectedRequest = useAppSelector(currentSelectedRequest);

  const headerCaption = prepareHeaderCaption(
    pageType,
    selectedRequest,
    isMobile
  );
  return headerCaption;
};
